"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AIRASIA_CLASSIC = {
  colors: {
    default: '#FFFFFF',
    primary: '#DC3224',
    primaryDark: '#C92D21',
    primaryLight: '#FBEBE9',
    secondary: '#4B4FA6',
    secondaryDark: '#4448A0',
    secondaryLight: '#EDEDF6',
    secondaryBlue: '#4B4FA6',
    tertiary: '#067E41',
    tertiaryDark: '#036835',
    tertiaryLight: '#E6F2EC',
    turquoise: '#0E7EA0',
    orange: '#C94318',
    orangeDark: '#B73810',
    orangeDarkMedium: '#F3693F',
    orangeDarkActive: '#C6472A',
    orangeLight: '#FAECE8',
    blue: '#2F73D2',
    blueDark: '#2765BD',
    blueMedium: '#436BA3',
    blueLight: '#EAF1FB',
    yellow: '#D97F00',
    green: '#067E41',
    greenLight: '#E6F2EC',
    neutral: '#212124',
    greyDarker: '#4C4C50',
    greyDark: '#75767A',
    greyMediumDark: '#DADADA',
    greyMedium: '#C5C9D0',
    greyLight: '#D9DBE0',
    greyLighter: '#F8F8F8',
    greyLightest: 'rgba(217, 219, 224, 0.5)',
    gray: '#e5e5e5',
    black: '#000000',
    pinkLighter: '#FFDEDE'
  },
  backgroundColor: {
    default: '#FFFFFF',
    primary: '#F8F8F8',
    secondary: '#212124',
    tertiary: '#C5C9D0',
    blueLight: '#EAF1FB',
    redLight: '#FBEBE9',
    green: '#067E41',
    greenLight: '#E6F2EC',
    yellowLight: '#FFF4E6',
    greyLight: '#EFEFEF',
    greyLighter: '#F8F8F8',
    greyDarker: '#4C4C50',
    greyLine: '#c4c4c4',
    black: '#000000',
    blue: '#4B4FA6',
    blueActive: '#D9EFFF',
    secondaryBlue: '#4B4FA6',
    secondaryLight: '#EDEDF6'
  },
  fontFamily: {
    default: 'DM Sans',
    secondary: 'Libre Baskerville'
  },
  fontSize: {
    XXSmall: '0.3rem',
    semiXSmall: '0.5rem',
    XSmall: '0.75rem',
    small: '0.875rem',
    normal: '1rem',
    medium: '1.125rem',
    sNormal: '1.01rem',
    titleSmall: '1.25rem',
    titleNormal: '1.5rem',
    titleMedium: '2rem',
    titleLarge: '3rem',
    titleExtraLarge: '4rem',
    titleXXLarge: '5rem'
  },
  fontWeight: {
    normal: 400,
    medium: 500,
    bold: 500,
    semiLarge: 600,
    large: 700
  },
  space: {
    none: '0px',
    mini: '2px',
    nano: '3px',
    micro: '4px',
    xxtiny: '6px',
    xtiny: '7px',
    tiny: '8px',
    XXXSmall: '10px',
    XXSmall: '11px',
    XSmall: '12px',
    semiSmall: '14px',
    small: '16px',
    medium: '18px',
    normal: '20px',
    standard: '24px',
    extraStandard: '26px',
    semi: '32px',
    semiMedium: '36px',
    semiLarge: '40px',
    semiXLarge: '45px',
    large: '48px',
    XLarge: '64px',
    semiXXLarge: '80px',
    semiXXXLarge: '108px',
    XXLarge: '128px',
    XXXLarge: '180px',
    XXXXLarge: '360px'
  },
  lineHeight: {
    XSmall: '14px',
    XXSmall: '16px',
    small: '18px',
    normal: '20px',
    semiLarge: '21px',
    large: '22px',
    XLarge: '24px',
    XXLarge: '28px',
    titleSmall: '30px',
    titleNormal: '36px',
    titleMedium: '48px',
    titleLarge: '72px'
  },
  borderRadius: {
    small: '3px',
    normal: '4px',
    medium: '16px',
    large: '40px',
    XLarge: '50px'
  }
};
var _default = AIRASIA_CLASSIC;
exports.default = _default;